import { Button, Modal } from '@cimplico/components';
import { motion } from 'framer-motion';
import { useState } from 'react';

import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { formatMixedCase } from '../../utilities/formatting';
import UpdateTrialBalanceForm from '../update-trial-balance/UpdateTrialBalanceForm';
import VerticalRadioInput from '../../components/radio-input/VerticalRadioInput';

type UploadTrialBalanceModalProps = {
    onClose: () => void;
    onSave: () => void;
};

function UploadTrialBalanceModal({ onClose, onSave }: UploadTrialBalanceModalProps): JSX.Element {
    const { accountingBasis } = useWorkpaperContext();
    const [uploadTrialBalance, setUploadTrialBalance] = useState('yes');

    return (
        <Modal isOpen={true} onClose={onClose}>
            <motion.div
                className="relative"
                initial={false}
                transition={{ duration: 0.2 }}
                animate={{
                    minHeight: 200,
                    minWidth: 500,
                }}
            >
                <motion.div className="flex flex-col h-full mx-auto p-8 text-left">
                    <div className="flex flex-col items-start gap-2">
                        <h1 className="text-xl leading-6 font-medium text-gray-900">Upload New Trial Balance</h1>
                        <VerticalRadioInput
                            title={`Do you want to update your trial balance for the new ${formatMixedCase(accountingBasis)} basis?`}
                            description=""
                            optionOneLabel="Yes"
                            optionTwoLabel="No"
                            value={uploadTrialBalance}
                            onValueChange={setUploadTrialBalance}
                        />
                    </div>
                    {uploadTrialBalance === 'yes' && <UpdateTrialBalanceForm onClose={onClose} />}
                    {uploadTrialBalance === 'no' && (
                        <div className="flex justify-end gap-4">
                            <Button type="hollow" label="Cancel" onClick={onClose} />
                            <Button type="primary" label="Save" onClick={onSave} />
                        </div>
                    )}
                </motion.div>
            </motion.div>
        </Modal>
    );
}

export default UploadTrialBalanceModal;
